import React from 'react';
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import {bindActionCreators} from 'redux'

import config from '../../config.js'
import photo_peter from '../../images/Polymedia-Peter_van_der_Meer.jpg'
import icon_fb from '../../images/facebook-dieetclub-dieetpuntclub.png'
import icon_li from '../../images/linkedin-dieetclub-dieetpuntclub.png'

import LineFormAccount from 'Skelet/src/components/LineFormAccount.js';

import {setMetatags, removeMarkdown} from '../../modules/metatag_functions.js'
import {fetchDataIfReady} from 'Skelet/src/modules/fetch.action.js'
import {translateMarkdown} from 'Skelet/src/modules/markdown.js'


class Blog extends React.Component {

  constructor(props) {
    super(props);

    let ref_id = false;
    let blog_path = this.props.pathname.replace("/blog/", "");
    if(blog_path !== "" && blog_path !== "/blog") {
      let splitted = blog_path.split("-");
      if(splitted.length > 0) {
        ref_id = splitted.pop();
      }
    } else {
      this.props.push("/blogs");
    }

    this.state = {ref_id};
  }

  componentWillMount() {
    if(this.state.ref_id) {
      let {ref_id} = this.state;
      if(this.props.session_token) {
        this.props.fetchDataIfReady(config.api_token, "blog_"+ref_id, "GET", config.api_url+"/blog?ref_id="+ref_id+"&t="+this.props.session_token);
      } else {
        this.props.fetchDataIfReady(config.api_token, "blog_"+ref_id, "GET", config.api_url+"/blog?ref_id="+ref_id);
      }
    }
  }

  render() {
    let {ref_id} = this.state;
    let blog_card = null, end_of_list_text = "", blog_data = this.props.apiData["blog_"+ref_id];

    let has_data = blog_data !== undefined && blog_data.data !== undefined && blog_data.data !== null && blog_data.data.ref_id !== undefined;
    if(has_data) {
      let blog = blog_data.data;
      let cd = new Date(blog.created_at);
      let cd_txt = cd.getDate()+" "+cd.toLocaleString('default', { month: 'long' })+" "+cd.getFullYear();
      let cd_time = <time dateTime={cd.getFullYear()+"-"+(cd.getMonth()+1)+"-"+cd.getDate()}>{cd_txt}</time>;
      let ud = new Date(blog.updated_at);
      let ud_txt = ud.getDate()+" "+ud.toLocaleString('default', { month: 'long' })+" "+ud.getFullYear();
      let ud_time = <time dateTime={ud.getFullYear()+"-"+(ud.getMonth()+1)+"-"+ud.getDate()}>{ud_txt}</time>;

      let join_cta = <div><div className="col-3-4"><h2 style={{fontWeight:"400", fontSize:"1em", textAlign:"center", margin:"1em 0 2.3em"}}><b>Om het platform goed te beginnen zijn de eerste 300 gebruikers direct Clublid, helemaal gratis! Dit zal de gehele looptijd zo blijven, zo lang jouw account blijft bestaan.{/*De basis is gratis.*/} <span className="contact-label" style={{background:"#ff9934"}}>nog 274 gratis</span></b></h2></div><div className="col-4"><LineFormAccount form_content={this.state.form_content} config={config} register_cta="Start NU als Clublid" /></div></div>;
      let author_card = null;
      if(true) { // net als original_publisher nog checks van maken :)
        author_card = <div className="card">
          <div style={{display:"inline-block", width:"15%"}}><div className="image-container"><img src={photo_peter} alt={"Dieet.Club | Peter van der Meer"} style={{maxWidth:"100px", maxHeight:"100px", borderRadius:"16px"}} /></div></div>
          <div style={{display:"inline-block", width:"85%", paddingLeft:"7px", verticalAlign:"top"}}><h2 style={{margin:".1em 0"}}>Peter van der Meer</h2><p style={{fontSize:"85%"}}>Ontwikkelaar Dieet.Club, ik schrijf over van alles wat me interesseert. Momenteel eet ik veel koolhydraatarm, en met Intermittent Fasting eet ik enkel tussen 12 en 7. Daarnaast fitness ik drie keer per week, voornamelijk krachttraining, en loop ik graag.</p><div style={{marginTop:".7em"}}><a href="https://www.facebook.com/DieetPuntClub/" target="_blank" rel="noopener noreferrer"><img src={icon_fb} alt="Facebook" style={{background:"#000", borderRadius:"3px", width:"24px", marginRight:"3px"}} /></a><a href="https://www.linkedin.com/in/peterdotplus" target="_blank" rel="noopener noreferrer"><img src={icon_li} alt="Li" style={{background:"#000", borderRadius:"3px", width:"24px", marginRight:"3px"}} /></a></div></div>
        </div>;
      }
      let disclaimer_card = <div style={{border:"3px solid #555", padding:".8em"}}>Dieet.Club geeft informatie en entertainment over gezondheid en gerelateerde onderwerpen. De informatie, andere inhoud en gelinkte onderdelen zijn niet bedoeld als medisch advies. Geen enkele inhoud op deze website moet gebruikt worden als alternatief voor direct medisch advies van jouw huisarts of een vergelijkbare behandelaar.</div>;

      let mapped_text = null;
      if(blog.text !== "") {
        mapped_text = translateMarkdown(blog.text);
      }

      blog_card = <div className="col-1"><div className="card">
        <div className="image-container"><img src={"https://images.dieet.club/"+blog.img_fn} alt={"Dieet.Club | "+blog.title} /></div>
        <h1 style={{padding:"0 1.4rem", margin:"3rem 0", textAlign:"left"}}>{blog.title}</h1>
        <div className="blog-content" style={{padding:"0 1.4rem", marginBottom:"3rem"}}>{mapped_text}</div>
        <small style={{opacity:".5", display:"block", fontSize:"75%", textAlign:"right"}} title={blog.created_at}>Gepubliceerd: {cd_time}</small>
        {(blog.created_at !== blog.updated_at) && <small style={{opacity:".5", display:"block", fontSize:"75%", textAlign:"right"}} title={blog.updated_at}>Laatst aangepast: {ud_time}</small>}
      </div>{!this.props.session_token && join_cta}{author_card}{disclaimer_card}</div>;

      setMetatags(blog.title+" | Blog Peter van der Meer", removeMarkdown(blog.text), "https://images.dieet.club/"+blog.img_fn, "article", this.props.pathname, blog.updated_at);
    }

    if(blog_data === undefined || blog_data.isFetching) {
      end_of_list_text = "Laden..";
    } else if((blog_data !== undefined && !blog_data.isFetching)) {
      if(blog_data.data[0] !== undefined) {
        // end_of_list_text = "Einde van resultaten.";
      } else {
        // end_of_list_text = "Geen blogs.";
      }
    }

    return (
      <div className="container content">
        {has_data && blog_card}
        <div className="end_of_list_text">{end_of_list_text}</div>
      </div>
    );
  }

}


function mapStateToProps(state) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
    apiData: state.apiData,
    pathname: state.router.location.pathname,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    push,
    fetchDataIfReady,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Blog)



// WEBPACK FOOTER //
// ./src/containers/StartPages/Blog.js